import {CSSProperties, FC} from 'react';


export interface IIconPhoneBmwProps {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconPhoneBmw: FC<IIconPhoneBmwProps> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path fillRule="evenodd" d="m13.072 15.69 1.991-1.054a.773.773 0 0 1 .383-.094c.281 0 .537.14.664.351l1.788 2.859a.613.613 0 0 1 .102.35.697.697 0 0 1-.384.61L15.191 20c-3.676-1.827-5.131-3.49-6.816-6.137C6.715 11.216 6 9.201 6 5.383l2.425-1.29A.782.782 0 0 1 8.81 4c.28 0 .536.142.663.352l1.788 2.835a.648.648 0 0 1 .102.375.638.638 0 0 1-.383.585L8.987 9.2l4.085 6.488Z" clipRule="evenodd" />
        </svg>
    );
};
